import { SECURITY_QUESTIONS_API_URL } from "../config/constants";
import { REGISTER_API_URL } from "../pages/Registration/registration.utils";
import { apiFetch } from "../utils/apiClient";


const parseJsonSafely = (value) => {
  if (!value.trim()) {
    return undefined;
  }

  try {
    return JSON.parse(value);
  } catch {
    return undefined;
  }
};

const extractErrorMessage = async (response, fallback) => {
  try {
    const raw = await response.text();
    const data = parseJsonSafely(raw);
    if (typeof data?.message === "string" && data.message.trim()) {
      return data.message;
    }

    if (raw.trim()) {
      return raw;
    }
  } catch {
    // Use the fallback message.
  }

  return fallback;
};

export async function getSecurityQuestions() {
  const response = await apiFetch(SECURITY_QUESTIONS_API_URL, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  }, "Failed to fetch security questions", { passthrough: [401] });
  console.log("Security Questions Response:", response);
  if (!response.ok) {
    throw new Error(await extractErrorMessage(response, "Failed to fetch security questions"));
  }

  const payload = (await response.json().catch(() => []));
  console.log("Security Questions Payload:", payload);
  return Array.isArray(payload) ? (payload ) : [];
}

export async function registerUser(payload) {
  const response = await apiFetch(REGISTER_API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      userId: payload.uid,
      firstName: payload.firstName,
      lastName: payload.lastName,
      password: payload.password,
      questionId: payload.questionId,
      securityAnswer: payload.securityAnswer,
    }),
  }, "Registration failed. Please try again.", { passthrough: [401] });

  const rawResponse = await response.text();
  const data = parseJsonSafely(rawResponse);

  if (!response.ok) {
    const message = data?.message || rawResponse || `Registration failed (${response.status})`;
    throw new Error(message);
  }

  if (data) {
    if (data.status !== "SUCCESS") {
      throw new Error(data.message || `Registration failed (${response.status})`);
    }

    return data;
  }

  return {
    status: "SUCCESS",
    message: rawResponse || "Registration completed.",
    token: undefined,
    tokenType: undefined,
    expiresIn: undefined,
  };
}
